import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { Observable } from 'rxjs';

import { DialogYesNoComponent } from '../components/dialog-yes-no/dialog-yes-no.component';
import { BaseManagement } from './base-management';
import { DynamicFormService } from './dynamic-form.service';

import { UtilsService } from './utils.service';

declare var $: any;

export class BaseDynamicForm extends BaseManagement {
	formData: any = {};
    savedData: any = {};
    formQty: any = 3;

    costs: any = [];
    costsTotal: any = 0;
    
	constructor(
	){
		super();
	}
	
	generateDataForSave(formQty){
		this.formData = [];

		for (var i = 1; i <= formQty; i++) {
			this.formData.push(this["form"+i].value);
			console.log(this.formData);
		}

		this.formData = {
			"data": this.formData
		};
	}

	prepareFormFromData(formQty, requirement:any){
		return new Promise((resolve, reject) => {
			var data = (requirement.ProcessJson) ? JSON.parse(requirement.ProcessJson).data : [];

			for (var i = 0; i <= data.length-1; i++) {
				this["form"+(i+1)].patchValue(
					data[i]
				);
			}	
			resolve(data)	
		});
	}

	prepareIDFormFromData(formQty, requirement:any){
		return new Promise((resolve, reject) => {
			var data = (requirement.ProcessJson) ? JSON.parse(requirement.ProcessJson) : [];

			this["form1"].patchValue(
					data
			)		

			resolve(data);
		});
	}

	resetControlRules(rules){
		rules.forEach((rule)=>{
			if(rule.enable){
	            rule.control.enable();
	            rule.control.setValidators(Validators.required);
			}else{
	            rule.control.reset()
	            rule.control.clearValidators();
	            rule.control.disable();							
			}
		});
	}

    returnInvalidControllers(form, controls){
       const invalid = [];
       for (const name in controls) {
           if (controls[name].invalid) {
               invalid.push(name);
           }
       }
       
       console.log(form + ' invalid controls: ' + invalid);
    }	

    onStepChange(index){
        // if(!this.dynamicFormService.isReadOnly && !this.dynamicFormService.isInRevisionMode){
        //     this.save(false);    
        // }        
    }	

	save(isComplete){
		// return new Promise( (resolve, reject) => {
	 //        if(this.isSaving()) return;

	 //        this.dynamicFormService.isComplete = isComplete;

	 //        this.generateDataForSave(this.formQty);

	 //        this.startSaving("saving");

	 //        this
	 //        .dynamicFormService
	 //        .save(this.formData)
	 //        .then(()=>{
	 //            this.stopSaving();            

	 //            this.dynamicFormService.formCommunicator.next("stop-saving");

	 //            if(isComplete){
	 //            	this.dynamicFormService.formLoaderIsVisible = false;
	 //                resolve();                           
	 //            }        
	 //        });			       
		// });	        
	}

	saveCosts(){
		// return new Promise( (resolve, reject) => {
	 //        if(this.isSaving()) return;

	 //        this.startSaving("saving");

	 //        this
	 //        .dynamicFormService
	 //        .saveCosts(this.costs, this.costsTotal)
	 //        .then(()=>{
	 //            this.stopSaving();            

	 //            resolve();    
	 //        });			       
		// });			
	}


}
